import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { captureException } from "@sentry/browser";
import { showNotification } from "../../notification/actions";

import { MOVE_TASK } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";

export default (data: { index: number, planId: string }) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: boolean }>("/move-task", data);
        dispatch({
            type: MOVE_TASK,
            payload: { ...res, ...data },
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};